<template>
	<div class="filters-box-row">
		<div class="filters-container">
			<div class="input-box">
				<el-select v-model="discountState" style="margin-right:10px" size='mini'>
					<el-option :value="-1" label="全部状态"></el-option>
					<el-option :value="1" label="未生效"></el-option>
					<el-option :value="0" label="进行中"></el-option>
					<!-- <el-option :value="2" label="已结束"></el-option> -->
				</el-select>
				<el-input
					v-model="keyword"
					placeholder="请输入名称/编号"
					size="mini"
					>
					<el-button style="height:28px" slot="append" icon="el-icon-search" @click="onSearch"></el-button>
				</el-input>
			</div>
			<div style="margin-left: 20px">
				类型：
				<el-select v-model="type" size='mini'>
					<el-option :value="-1" label="全部"></el-option>
					<el-option :value="1" label="满减券"></el-option>
					<el-option :value="6" label="商品券"></el-option>
				</el-select>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Search',
	data () {
		return {
			discountState: -1,
			keyword: '',
			type: -1
		}
	},
	created () {
	},
	methods: {
		clearing () {
			this.discountState = -1
			this.keyword = ''
			this.onSearch()
		},
		onSearch () {
			let params = {
				discountState: this.discountState,
				keyword: this.keyword,
				page: 1,
				size: 20,
				type: this.type
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/coupon/list`,
				data: params
			}).then(res => {
				this.$emit('getTableData', res)
				this.$emit('getParamsData', params)
			}).catch(() => {
				this.$emit('getParamsData', params)
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.filters-box-row {
	display: flex;
	flex-direction column
	padding: 10px 0;
	width :100%;
	line-height :60px;
	min-width :600px;
	border-bottom 1px solid #dce2fd;
	box-sizing: border-box
	.filters-container {
		display flex
		flex: 1
		height: 60px
		.input-box {
			display flex;
			align-items: center;
			width: 450px;
			margin-left: 20px
		}
	}
}
</style>
